import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { LoadingFieldDropdown } from '@/components';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const OutboundCallerIDField = ({
    darkMode,
    values,
    setFieldValue,
    onError,
    outboundCallerIDOptions,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    // Hide field while options are loading (undefined) or when there are no options (empty array)
    const isLoading = outboundCallerIDOptions === undefined;
    const noOptions =
        outboundCallerIDOptions && outboundCallerIDOptions.length === 0;

    // Don't render anything during loading, when no options available, or no companyID
    // This prevents layout shifts and overlapping issues
    if (!values?.companyID || isLoading || noOptions) {
        return null;
    }

    return (
        <Box
            sx={{ marginTop: '2rem', marginBottom: '2rem' }}
            // border='2px solid red'
            borderRadius="8px"
            p="0.2rem">
            <FormControl
                sx={{ margin: '0 !important' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={stackStyling(true)}>
                    <Box>
                        <FormLabel sx={formLabelStyling(darkMode)}>
                            Outbound Caller ID
                        </FormLabel>
                        <Text sx={descriptionStyling} maxWidth={250}>
                            This will overwrite the CLI presentation for ALL
                            numbers in the block.
                        </Text>
                    </Box>
                    <Box flex="1" minWidth="450px">
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'flex-start',
                                paddingTop: '15px',
                            }}>
                            <VStack width="100%" alignItems="normal">
                                <LoadingFieldDropdown
                                    searchable
                                    staticEnum={outboundCallerIDOptions}
                                    fieldName=""
                                    dropDownValue="telephoneNumber"
                                    displayField="display"
                                    onChange={(v) => {
                                        setFieldValue('cliPresentation', v);
                                    }}
                                    fieldValue={values.cliPresentation}
                                    onError={onError}
                                />
                            </VStack>
                        </Box>
                    </Box>
                    {isHovered && (
                        <FieldToolTip
                            label="Warning: This will override CLI presentation for all numbers in this block"
                            ariaLabel="outbound-caller-id-tip"
                            left="25px"
                            top="25px"
                        />
                    )}
                </Stack>
            </FormControl>
        </Box>
    );
};

export default OutboundCallerIDField;
